<h2 mat-dialog-title>Select Portal</h2>
<mat-dialog-content>
  <div class="row" style="min-height: 30vh; width: 100%">
    <div class="col-md">
      <mat-form-field appearance="outline" class="w-100">
        <mat-select matInput [(ngModel)]="selectedItem">
          @for (val of userPortals; track $index){
          <mat-option [value]="val['id']">
            {{ val['itemName'] }}
          </mat-option>

          }
        </mat-select>
      </mat-form-field>
      <!-- <angular2-multiselect  [data]="userPortals"
                                       [(ngModel)]="selectedItem"
                                       [settings]="userPortalsDropDownSettings"
                                       (onDeSelectAll)="OnDeSelectAll()">
                </angular2-multiselect> -->
    </div>
    <!--  <div class="col-md-4">-->
    <!--    <button class="btn btn-sm btn-success" (click)="selectPortal()">Select</button>-->
    <!--  </div>-->
  </div>
</mat-dialog-content>
<mat-dialog-actions class="pull-right">
  <!-- <button class="btn btn-sm btn-success pull-right" (click)="selectPortal()">
    Select
  </button> -->
  <button
    mat-raised-button
    type="submit"
    color="primary"
    (click)="selectPortal()"
  >
    Select
  </button>
</mat-dialog-actions>
